import { render, staticRenderFns } from "./Statuswahl.vue?vue&type=template&id=dcfc96fc&"
import script from "./Statuswahl.vue?vue&type=script&lang=js&"
export * from "./Statuswahl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports